export default __webpack_public_path__ + "static/media/Initiate's Gloves of Awakening.ab50eb9f.jpg";